




























































//import {db, functions} from "@/scripts/firebase";
import { GroupData } from "@/scripts/datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
//import { buildTimeColsModel } from "node_modules/@fullcalendar/timegrid/main";
//import { User } from 'firebase';

@Component

export default class GroupList extends Mixins(Common) {
  groups: GroupData[] = []
  groupsProps = {} as {[key: string]: {hidden: boolean}}
  isLoading = false
  orderBy: keyof GroupData = 'creationTime'
  columns = [
    {
      field: 'name',
      order: true
    },
    {
      field: 'description',
    },
     {
      field: 'members',
    },
    {
      field: 'disabled',
      order: true
    },
    {
      field: 'creationTime',
      order: true
    }
  ]

  get observer(){
    return this.$refs.groupListSearchFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  search = ''

  searchResult = ''

  searchResultsNum = 0
  
  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0
    this.groups.forEach((cl) => {
      if(cl.groupId){
        if(val.length === 0){
          this.$set(this.groupsProps, cl.groupId , {hidden: false})
          return
        }

        if(cl.name.indexOf(val) > -1 || cl.description.indexOf(val) > -1 || Object.values(cl.memberMeta).some((member) => {return this.$findTextByUserProfile(val,member)})){
          this.$set(this.groupsProps, cl.groupId , {hidden: false})
          searchResultsNum ++
          return
        }

          this.$set(this.groupsProps, cl.groupId , {hidden: true})
      }
    })

    if(val && searchResultsNum === 0){
      this.searchResult = this.$t('groupList.notFound') as string
    }else{
      this.searchResult = ''
    }
    this.searchResultsNum = searchResultsNum
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const groupsRef = await this.$getGroupsColRef().where('deleted','==',false).get()
      this.groups = groupsRef.docs.map( (doc) => {
        const row = doc.data() as GroupData
        return {groupId: doc.id,...row}
      });
      console.log(this.groups)
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  sortUser(index: number){
    /**
     * 名前のときよみがなで並べ替えるとかもうすこし工夫
     */
    let orderBy = this.columns[index].field
    if(orderBy == 'role'){
      orderBy = 'accessLevel'
    }

    if(orderBy == 'firstName' || orderBy == 'lastName' ){
      orderBy += 'Yomigana'
    }

    if(this.orderBy == orderBy){
      this.columns[index].order = ! this.columns[index].order
    }else{
      this.orderBy = orderBy as keyof GroupData
    }

    this.groups.sort((a, b) => {
      const nameA = a[this.orderBy] || Number.MIN_SAFE_INTEGER
      const nameB = b[this.orderBy] || Number.MIN_SAFE_INTEGER

      if(nameA === nameB){
        return 0
      }else if(this.columns[index].order && nameA > nameB){
        return 1
      }else{
        return -1
      }
    });
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
